import { _ } from "libs";

import React from "react";
import { Form, Field } from "react-final-form";
import withRedux from "../withRedux";
import { register, socialLogin } from "../actions";
import isEmail from "validator/lib/isEmail";
import isEmpty from "validator/lib/isEmpty";
import FacebookLogin from "./facebookLogin";
import GoogleLogin from "./googleLogin";
import reactToString from "../libs/reactToString";
import Loader from "./loader";
import Loadable from "react-loadable";

const required = (value: any) => (value ? undefined : _("validation.mustBeFilled"));
const mustBeEmail = (value: string) => {
	if (typeof value === "string") {
		return !isEmail(value) ? _("validation.mustBeValidEmail") : undefined;
	}

	return _("validation.mustBeValidEmail");
};

const mustBeFilled = (value: string) => {
	if (value === undefined) {
		value = "";
	}
	return isEmpty(value, { ignore_whitespace: true }) ? _("validation.mustBeFilled") : undefined;
};

const mustHaveLength = (minLength: number) => (value: string) => {
	if (value === undefined) {
		value = "";
	}
	return value.length < minLength
		? _("validation.mustAtLeastXCharactersLong", null, { minLength: minLength })
		: undefined;
};

const mustBeValidName = (value: string) => {
	if (typeof value === "string") {
		return isEmpty(value) ? _("validation.mustBeValidName") : undefined;
	}

	return _("validation.mustBeValidName");
};

const composeValidators = (...validators) => (value: any) =>
	validators.reduce((error, validator) => error || validator(value), undefined);

const PasswordInputWithStrength = Loadable({
	loader: () => import("./forms/controls/passwordInputWithStrength"),
	loading: Loader,
});

const RegisterForm = ({ register, socialLogin, destination }) => {
	return (
		<div className="auth-form register-form">
			<div>
				<Form
					onSubmit={(values, mutators) => {
						const locale = window.navigator.language;
						const { firstName, lastName, email, password } = values as any;
						register(firstName.trim(), lastName.trim(), email.trim(), password.trim(), locale, destination);
					}}
					render={({ handleSubmit, submitting, pristine, invalid, values }) => (
						<form onSubmit={handleSubmit} className="form-signin lite" autoComplete="off">
							<Field name="firstName" validate={mustBeValidName}>
								{({ input, meta }) => (
									<div className="field size_m">
										<label>{_("form.firstName.label")}</label>
										<input
											type="text"
											{...input}
											//placeholder={_("registerForm.firstName.placeholder")}
										/>
										{meta.touched && meta.error && <p className="error">{meta.error}</p>}
									</div>
								)}
							</Field>
							<Field name="lastName" validate={mustBeValidName}>
								{({ input, meta }) => (
									<div className="field size_m">
										<label>{_("form.lastName.label")}</label>
										<input
											type="text"
											{...input}
											//placeholder={_("registerForm.lastName.placeholder")}
										/>
										{meta.touched && meta.error && <p className="error">{meta.error}</p>}
									</div>
								)}
							</Field>
							<Field name="email" validate={mustBeEmail}>
								{({ input, meta }) => (
									<div className="field size_m">
										<label>{_("form.email.label")}</label>
										<input
											type="email"
											{...input}
											placeholder={_("registerForm.email.placeholder")}
										/>
										{meta.touched && meta.error && <p className="error">{meta.error}</p>}
									</div>
								)}
							</Field>
							<Field name="password" validate={composeValidators(mustBeFilled, mustHaveLength(8))}>
								{({ input, meta }) => (
									<div className="field size_m">
										<label>{_("form.password.label")}</label>
										<PasswordInputWithStrength
											{...input}
											placeholder={_("registerForm.password.placeholder")}
											minLength={8}
										/>
										{meta.touched && meta.error && <p className="error">{meta.error}</p>}
									</div>
								)}
							</Field>

							<Field name="agree" type="checkbox" validate={required}>
								{({ input, meta }) => (
									<div className="field checkbox small agree_to_tos_and_pp">
										<input {...input} type="checkbox" id="field_terms_and_privacy" />
										<label
											htmlFor="field_terms_and_privacy"
											dangerouslySetInnerHTML={{
												__html: _("registerForm.termsAndPrivacy.label", null, {
													termsLink: reactToString(
														<a href="https://www.gotcourts.com/tos" className="plain">
															{_("links.termsOfService")}
														</a>
													),
													privacyLink: reactToString(
														<a href="https://www.gotcourts.com/policy" className="plain">
															{_("links.privacyPolicy")}
														</a>
													),
												}),
											}}
										/>
									</div>
								)}
							</Field>
							<button type="submit" className="button" disabled={submitting || pristine || invalid}>
								{_("registerForm.btnRegister.label")}
							</button>
							<div className="social_login">
								{_("loginForm.socialLogin.text")}&nbsp;
								<FacebookLogin
									appId={process.env.REACT_APP_FB_APP_ID}
									onLogin={socialLogin.bind(this, "_facebook")}
								/>
								&nbsp;/&nbsp;
								<GoogleLogin
									appId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
									onLogin={socialLogin.bind(this, "_google")}
								/>
							</div>
						</form>
					)}
				/>
			</div>
		</div>
	);
};

export default withRedux({ register, socialLogin })(RegisterForm);
